export default "__VITE_ASSET__xME3jNyJ__"